import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CoordsValidation {
  static validate (control: AbstractControl): ValidationErrors | null {
    const { value } = control;
    const regex = '^-?\d+(\.\d+)?$';
    if (!value || value < -180 || value > 180 || value.toString().match(regex)) {
      return { invalidCoords: true };
    }

    return null;
  }
}
